import React from 'react';

export default () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.7778 6V8C15.8574 8 16.7407 8.9 16.7407 10V17C16.7407 18.1 15.8574 19 14.7778 19H4.96296C3.88333 19 3 18.1 3 17V10C3 8.9 3.88333 8 4.96296 8V6C4.96296 3.24 7.16148 1 9.87037 1C12.5793 1 14.7778 3.24 14.7778 6ZM7.90741 6V8H11.8333V6C11.8333 4.9 10.95 4 9.87037 4C8.79074 4 7.90741 4.9 7.90741 6ZM10.6556 16.25V14.08C11.3426 13.77 11.8333 13.07 11.8333 12.25C11.8333 11.15 10.95 10.25 9.87037 10.25C8.79074 10.25 7.90741 11.15 7.90741 12.25C7.90741 13.07 8.39815 13.77 9.08518 14.08V16.25H10.6556V16.25Z" fill="currentColor" />
  </svg>
);
